import { Modal } from '@/types/shared'
import { create } from 'zustand'

export type SidePanelKind = 'alerts' | 'notifications' | 'whats-new'

interface AppStore {
    sideBarFull: boolean
    setSideBarFull: (sideBarFull: boolean) => void
    modal: Modal | null
    setModal: (modal: Modal | null) => void
    isShowHelp: boolean
    setIsShowHelp: (isShowHelp: boolean) => void
    helpContent: string
    setHelpContent: (helpContent: string) => void
    helpTitle: string
    setHelpTitle: (helpTitle: string) => void
    showHelp: (content: string, title?: string) => void
    hideHelp: () => void
    sidePanel: SidePanelKind | null
    toggleSidePanel: (kind: SidePanelKind) => void
    closeSidePanel: () => void
}

export const useAppStore = create<AppStore>((set) => ({
    sideBarFull: true,
    setSideBarFull: (sideBarFull: boolean) => set({ sideBarFull }),
    modal: null,
    setModal: (modal: Modal | null) => set({ modal }),
    isShowHelp: false,
    setIsShowHelp: (isShowHelp: boolean) => set({ isShowHelp }),
    helpContent: '',
    setHelpContent: (helpContent: string) => set({ helpContent }),
    helpTitle: '',
    setHelpTitle: (helpTitle: string) => set({ helpTitle }),
    showHelp: (content: string, title?: string) =>
        set({
            isShowHelp: true,
            helpContent: content,
            helpTitle: title || '',
            sidePanel: null,
        }),
    hideHelp: () => set({ isShowHelp: false, helpContent: '', helpTitle: '' }),
    sidePanel: null,
    // One panel is docked beside the page at a time: opening one closes help.
    toggleSidePanel: (kind) =>
        set((state) => ({
            sidePanel: state.sidePanel === kind ? null : kind,
            isShowHelp: false,
            helpContent: '',
            helpTitle: '',
        })),
    closeSidePanel: () => set({ sidePanel: null }),
}))
